import FileTransfer from '~/sqlite/services/fileTransfer';

export class FileLocalDataSource extends FileTransfer {}

export const fileLocal = new FileLocalDataSource();
